import TimeLineImport from "./components/TimeLineImport";
import TimeLinePicking from "./components/TimeLinePicking";
import TimeLineShipment from "./components/TimeLineShipment";
import TimeLineCompleted from "./components/TimeLineCompleted";
import TimeLineUpdate from "./components/TimeLineUpdate";
import TimeLineDelete from "./components/TimeLineDelete";
import TimeLineCreate from "./components/TimeLineCreate";
import TimeLineShipmentConfirmed from "./components/TimeLineShipmentConfirmed";
import TimeLineShipmentMailed from "./components/TimeLineShipmentMailed";
import TimeLineProvisionalShipment from "./components/TimeLineProvisionalShipment";
import TimeLineSupportTicket from "./components/TimeLineSupportTicket";
import TimeLineEvent from "./components/TimeLineEvent";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';

const timeline_types = {
    default: 'default',
    create: 'create',
    read: 'read',
    update: 'update',
    delete: 'delete',
    import: 'import',
    shipment: 'shipment',
    shipmentconfirmed: 'shipmentconfirmed',
    shipmentmailed: 'shipmentmailed',
    provisionalshipment: 'provisionalshipment',
    completed: 'completed',
    picking: 'picking',
    supportticket: 'supportticket',
    event: 'event'
};

export const TIMELINE_COMPONENTS = (mode) =>  ({
    [timeline_types.default]: {
        comp: TimeLineImport,
        check: mode === "dark"  ? "blue" : "primary"
    },
    [timeline_types.read]: {
        comp: TimeLineImport,
        check: mode === "dark"  ? "blue" : "primary"
    },

    [timeline_types.shipmentconfirmed]: {
        comp: TimeLineShipmentConfirmed,
        check: "orange"
    },
    [timeline_types.shipmentmailed]: {
        comp: TimeLineShipmentMailed,
        check: "blue",
        icon: EmailOutlinedIcon
    },
    [timeline_types.create]: {
        comp: TimeLineCreate,
        check: mode === "dark"  ? "blue" : "primary"
    },
    [timeline_types.delete]: {
        comp: TimeLineDelete,
        check: "red"
    },
    [timeline_types.update]: {
        comp: TimeLineUpdate,
        check: mode === "dark"  ? "blue" : "primary"
    },
    [timeline_types.import]: {
        comp: TimeLineImport,
        check: mode === "dark"  ? "blue" : "primary"
    },
    [timeline_types.shipment]: {
        comp: TimeLineShipment,
        check: "purple",
        // The relation portal styles the shipment entry like the "completed" entry.
        relationCheck: "green"
    },
    [timeline_types.provisionalshipment]: {
        comp: TimeLineProvisionalShipment,
        check: "purple"
    },
    [timeline_types.completed]: {
        comp: TimeLineCompleted,
        check: "green"
    },
    [timeline_types.picking]: {
        comp: TimeLinePicking,
        check: mode === "dark"  ? "blue" : "primary"
    },
    [timeline_types.supportticket]: {
        comp: TimeLineSupportTicket,
        check: "pink",
        icon: SupportAgentOutlinedIcon
    },
    [timeline_types.event]: {
        comp: TimeLineEvent,
        check: "cyan",
        icon: EventNoteOutlinedIcon
    },
});


export const getTimeLineSettings = (state, theme, isRelation = false) => {
    const states = TIMELINE_COMPONENTS(theme);
    const settings = states[state];
    if (settings && isRelation && settings.relationCheck) {
        return { ...settings, check: settings.relationCheck };
    }
    return settings;
};
